import { Component, Inject, OnInit, ViewChildren } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "app-otp",
  templateUrl: "./otp.component.html",
  styleUrls: ["./otp.component.css"],
})
export class OtpComponent implements OnInit {
  form: FormGroup;
  remaining = 30;
  timerOn = true;
  routeParams: any;
  isLoading = false;
  phoneNumber: any;
  formInput = ["digit1", "digit2", "digit3", "digit4", "digit5", "digit6"];
  @ViewChildren("formRow") rows: any;

  constructor(
    public dialogRef: MatDialogRef<OtpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = this.toFormGroup(this.formInput);
    this.timer();
  }

  ngOnInit(): void {
   this.isLoading = false;
 //  this.renderer.removeClass(this.el.nativeElement, 'fade-background');
   this.phoneNumber = localStorage.getItem('pNo');
   localStorage.removeItem('pNo');
  }

  timer() {
    this.remaining -= 1;

    if (this.remaining > 0 && this.timerOn) {
      setTimeout(() => {
        this.timer();
      }, 1000);
      return;
    }

    if (!this.timerOn) {
      // Do validate stuff here
      return;
    }

    // Do timeout stuff here
    this.timerOn = false;
  }

  resendOTP() {
    this.remaining = 60;
    this.timerOn = true;
    this.timer();
  }

  toFormGroup(elements: any) {
    const group: any = {};

    elements.forEach((key: any) => {
      group[key] = new FormControl("", Validators.required);
    });
    return new FormGroup(group);
  }

  keyUpEvent(event: any, index: any) {
    let pos = index;
    if (event.keyCode === 8 && event.which === 8) {
      pos = index - 1;
    } else {
      pos = index + 1;
    }
    if (pos > -1 && pos < this.formInput.length) {
      this.rows._results[pos].nativeElement.focus();
    }
  }

  async onSubmit() {
    const code = Object.values(this.form.value).toString().replaceAll(",", "");
    this.dialogRef.close(code);
  }

}
